export default {
      id: "icon-unread-usage",
      viewBox: "0 0 6 6",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-unread",
      toString: function () {
        return this.url;
      }
    }